import { SET_CONFIG, SET_MAINTENANCE_INFO } from '../constants/actions'

const initialState = {
    units: [],
    devices: [],
    sites: [],
    profiles: [],
    pstnNumbers: [],
    maintenanceInfo: null,
    enablePolling: true
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_CONFIG:
            return { ...state, ...action.config }
        case SET_MAINTENANCE_INFO:
            return { ...state, maintenanceInfo: action.maintenanceInfo }
    }
    return state
}


// WEBPACK FOOTER //
// ./reducers/config.js